<template>
  <div class="row">
    <div class="col-sm-12 col-md-12">
      <b-container fluid>
        <b-row class="my-1">
          <b-col sm="6">
            <label>Name:</label>
            <b-form-input
              id="input-small"
              v-model="name"
              size="sm"
              placeholder="Enter restaurant name"
            ></b-form-input>
          </b-col>
          <b-col sm="6">
            <label>Gst:</label>
            <b-form-input
              id="input-small"
              v-model="gst_number"
              size="sm"
              placeholder="Enter gst"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="12">
            <label>Email:</label>
            <b-form-input
              id="input-small"
              v-model="email"
              size="sm"
              placeholder="Enter Email"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="6">
            <label>Address:</label>
            <b-form-textarea
              id="input-small"
              v-model="address"
              size="sm"
            ></b-form-textarea>
          </b-col>
          <b-col sm="4">
            <label>Location:</label>
            <b-form-input
              id="input-small"
              v-model="location"
              size="sm"
              placeholder="Enter Location"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="6">
            <label>Geo Latitude:</label>
            <b-form-input
              id="input-small"
              v-model="lat"
              size="sm"
              placeholder="Enter Latitude"
            ></b-form-input>
          </b-col>
          <b-col sm="6">
            <label>Geo Longitude:</label>
            <b-form-input
              id="input-small"
              v-model="lng"
              size="sm"
              placeholder="Enter Longitude"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="6">
            <label>City:</label>
            <select-with-search
              :full_object="true"
              :search_api="CityPath.GET_CITY"
              track_by="city"
              display="city"
              :selected_data="[city_old]"
              selected_by="city"
              @selectedOption="selectedCity"
            ></select-with-search>
          </b-col>
          <b-col sm="6">
            <label>State:</label>
            <b-form-input
              id="input-small"
              v-model="state"
              size="sm"
              placeholder="Enter state"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="6">
            <label>Country:</label>
            <b-form-input
              id="input-small"
              v-model="country"
              size="sm"
              placeholder="Enter country"
            ></b-form-input>
          </b-col>
          <b-col sm="6">
            <label>Zip Code:</label>
            <b-form-input
              id="input-small"
              v-model="zip_code"
              size="sm"
              placeholder="Enter zip code"
            ></b-form-input>
          </b-col>
          <b-col sm="6">
            <label>Food Type</label>
            <b-select
              :options="['veg', 'non_veg']"
              v-model="food_type"
            ></b-select>
          </b-col>
        </b-row>
        <b-row class="my-1 mt-2">
          <b-col sm="12">
            <b-button @click="saveRestaurant" class="btn btn-success"
              >Submit</b-button
            >
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { CityPath, RestaurantsPath } from "../../../../path";
import SelectWithSearch from "@/views/pages/Dilfoods/Common/SelectWithSearch";

export default {
  name: "add",
  components: { SelectWithSearch },
  props: ["selectedRestaurant"],
  data() {
    return {
      name: "",
      gst_number: "",
      email: "",
      description: "",
      address: "",
      city: "",
      city_old: "",
      state: "",
      country: "",
      zip_code: "",
      location: "",
      lat: "",
      lng: "",
      food_type: "",
      baseUrl: process.env.VUE_APP_API_BACKEND_URL,
    };
  },
  watch: {
    selectedRestaurant(v) {
      console.log(v);
      if (!v) {
        this.name = this.selectedRestaurant.name;
        this.email = this.selectedRestaurant.email;
        this.description = this.selectedRestaurant.description;
        this.address = this.selectedRestaurant.address;
        this.city = this.selectedRestaurant.city;
        this.city_old = this.selectedRestaurant.city;
        this.state = this.selectedRestaurant.state;
        this.country = this.selectedRestaurant.country;
        this.zip_code = this.selectedRestaurant.zip_code;
        this.location = this.selectedRestaurant.location;
        this.lat = this.selectedRestaurant.lat;
        this.lng = this.selectedRestaurant.lng;
        this.food_type = this.selectedRestaurant.food_type;
        this.gst_number = this.selectedRestaurant.gst_number;
      } else {
        this.name = "";
        this.email = "";
        this.description = "";
        this.address = "";
        this.city = "";
        this.state = "";
        this.country = "";
        this.zip_code = "";
        this.location = "";
        this.lat = "";
        this.lng = "";
        this.food_type = "";
        this.gst_number = "";
      }
    },
  },
  computed: {
    CityPath() {
      return CityPath;
    },
  },
  mounted() {
    this.name = this.selectedRestaurant.name;
    this.email = this.selectedRestaurant.email;
    this.description = this.selectedRestaurant.description;
    this.address = this.selectedRestaurant.address;
    this.city = this.selectedRestaurant.city;
    this.city_old = this.selectedRestaurant.city;
    this.state = this.selectedRestaurant.state;
    this.country = this.selectedRestaurant.country;
    this.zip_code = this.selectedRestaurant.zip_code;
    this.location = this.selectedRestaurant.location;
    this.lat = this.selectedRestaurant.lat;
    this.lng = this.selectedRestaurant.lng;
    this.food_type = this.selectedRestaurant.food_type;
    this.gst_number = this.selectedRestaurant.gst_number;
  },
  methods: {
    selectedCity(v) {
      console.log(v);
      this.city = v.city;
      this.state = v.state;
      this.country = v.country;
    },
    async saveRestaurant() {
      try {
        let res;
        if (Object.keys(this.selectedRestaurant).length > 0) {
          res = await axios.put(
            this.baseUrl +
              (this.selectedRestaurant
                ? RestaurantsPath.BASIC_RESTAURENT +
                  "/" +
                  this.selectedRestaurant.id
                : RestaurantsPath.BASIC_RESTAURENT),
            {
              name: this.name,
              email: this.email,
              description: this.description,
              address: this.address,
              city: this.city,
              state: this.state,
              country: this.country,
              zip_code: this.zip_code,
              location: this.location,
              lat: this.lat,
              lng: this.lng,
              food_type: this.food_type,
              gst_number: this.gst_number,
            }
          );
        } else {
          res = await axios.post(
            this.baseUrl + RestaurantsPath.BASIC_RESTAURENT,
            {
              name: this.name,
              email: this.email,
              description: this.description,
              address: this.address,
              city: this.city,
              state: this.state,
              country: this.country,
              zip_code: this.zip_code,
              location: this.location,
              lat: this.lat,
              lng: this.lng,
              food_type: this.food_type,
              gst_number: this.gst_number,
            }
          );
        }

        console.log(res);
        if (res.data.status == true) {
          this.$bvToast.toast("Successfully added", {
            title: `Restauratn added`,
            variant: "success",
            solid: true,
          });
          this.$bvModal.hide("bv-add-restaurant");
          this.$emit("update");
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style scoped></style>
